export default __webpack_public_path__ + "static/media/005-firework.012acdcf.svg";